import React from 'react';
import { withTranslation } from 'react-i18next';
import styled, { ThemeProvider } from 'styled-components'
import ReactSelect from '../../../components/ReactSelect';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as staticContentActions } from '../../../actions/static_content'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import GenericModal from '../../../components/GenericModal'

import { history } from '../../../store'


const Content = styled.div`

  padding: 15px 20px 20px 20px;

  > p {
    font-family: Lato-Regular;
    font-size: 14px;
    line-height: 22px;
    color: #2B2B2B;
    margin: 0px;
    margin-bottom: 0px;
  }

  > label {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: #666666;
    margin-top: 10px;
    margin-bottom: 7px;
    display: block;
  }
`

const Footer = styled.div`
  > button {
    height: 43px;
    width: calc(50% - 10px);
  }

  > button.cancel-change-language {
    margin-right: 10px;
  }

  > button.confirm-language-change {
    margin-left: 10px;
  }
`

const ChevronImage = styled.img`
  width: 14px;
  height: 8px;
  margin-right: 8px;
`


class ChangeLanguageDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: true,
      selectedLanguage: this.props.employee.language,
      buttonDisabled: true
    };
  }

  formatLanguagesOptions = (languages) => {
    let languagesOptions = languages.map(language => ({ value: language.code, label: language.name, className: 'available-language' }));
    return languagesOptions;
  }

  changeLanguageHandler = (selectedOption) => {
    let selectedValue = selectedOption ? selectedOption.value : "";
    if (selectedValue != this.props.employee.language){
      this.setState({ selectedLanguage: selectedValue, buttonDisabled: false});
    }
    else {
      this.setState({ buttonDisabled: true });
    }
  }

  yesButtonClickHandler = (callback) => {

    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if (isLive) {
        if (this.state.selectedLanguage != this.props.employee.language){
          this.props.onCloseDialog()
          this.props.actions.employee.changeLanguage(this.state.selectedLanguage).then(_ => {
            this.props.actions.employee.load()
            this.props.actions.static_content.load(this.state.selectedLanguage)
          })
        }
      } else {
        history.push("/maintenance", {})
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && (this.props.visible !== prevProps.visible)) {
      this.onOpenDialog();
    }
  }

  onOpenDialog = () => {
    this.setState({ selectedLanguage: this.props.employee.language });
  }

  render() {
    const { t } = this.props;

    return (
      <GenericModal
        title={t('ChangeLanguageDialog.HeaderLabel')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="change-language-modal"
      >
        <Content>
          <p>{t('ChangeLanguageDialog.PleaseChooseLabel')}</p>
          <label htmlFor="selected-language">{t('ChangeLanguageDialog.LanguageLabel')}</label>
          <ReactSelect
            name="selected-language"
            id="selected-language"
            className="custom-select available-languages"
            options={this.formatLanguagesOptions(this.props.configuration.languages)}
            onChange={this.changeLanguageHandler}
            value={this.formatLanguagesOptions(this.props.configuration.languages).find(lang => lang.value == this.state.selectedLanguage)}
            isClearable={false}
            isSearchable={false}
          />
        </Content>
        <Footer>
          <button className="cancel-change-language secondary-button" onClick={this.props.onCloseDialog}>{t('ChangeLanguageDialog.CancelButton')}</button>
          <button disabled={this.state.buttonDisabled} className="confirm-language-change primary-button" onClick={this.yesButtonClickHandler}>{t('ChangeLanguageDialog.YesButton')}</button>
        </Footer>
      </GenericModal>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    static_content: bindActionCreators(staticContentActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch)
  }
})

export default connect(mapState, mapDispatchToProps)((withTranslation('translations')(ChangeLanguageDialog)))
